export default "/images/a38ae1cc8bf9d5ef49807c8f12c9c6a3.avif";